import React from 'react';
import PushNotifications from '../../components/AdminNext/PushNotifications';
import HeadLessLayout from '../../components/Layout/HeadLessLayout';

function action({ store }) {
  if (!store.getState().runtime.isAdminAuthenticated) return { redirect: '/login' };

  return {
    title: 'Push notifications — Bas Recovery Admin',
    component: (
      <HeadLessLayout>
        <PushNotifications />
      </HeadLessLayout>
    )
  };
}

export default action;
